
import { mapState, mapActions, mapGetters } from "vuex";
import BrandOnlineStatusHandler from "../reciever/brand-online-status-handler.vue";
import BrandAssosciatedChannels from "../reciever/brand-assosciated-channels.vue";
import BrandAvatarWithColor from "../common/brand-avatar-with-color.vue";

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BrandOnlineStatusHandler,
    BrandAssosciatedChannels,
    BrandAvatarWithColor
  },
  computed: {
    ...mapGetters("restaurant", [
      "getAllBrands",
      "onlineChannelCount",
      "totalChannelCount"
    ])
  },
  methods: {
    handleAddNewBrand() {
      this.$emit("close-dialog");
      this.$emit("show-add-brand-dialog");
    }
  }
};
